var React = require('react');

function S3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"S3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M40.52,33,57.64,4.17A29.65,29.65,0,0,0,15.06,40.89h0A29.52,29.52,0,0,0,27.35,55.14L40.52,33Q39.68,30.46,40.52,33Z","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M42,68.51a29.68,29.68,0,0,0,.48-42L21.23,47.28h0L0,68a29.68,29.68,0,0,0,42,.48Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

S3.defaultProps = {"viewBox":"0 0 57.64 76.96"};

module.exports = S3;

S3.default = S3;
